<template>
    <ButtonPopover
        buttonClass="btn-base btn-transparent !pl-2 !pr-2 !py-1.5 h-10"
    >
        <template #button-content>
            <Icon icon="gear" class="w-5 h-5 icons-primary" />
            <span class="text-primary text-sm font-medium sm:inline hidden">
                Display
            </span>
            <Icon
                icon="chevron-down-small"
                class="sm:block hidden w-4 h-4 text-slate-400"
            />
        </template>
        <template #default>
            <section class="min-w-64 z-40 flex flex-col">
                <!-- Group By Dropdown -->
                <label
                    class="w-full h-9 p-2 rounded flex justify-between items-center"
                >
                    <div class="flex items-center gap-2 text-slate-800 dark:text-slate-100">
                        <Icon icon="groups" class="w-4 h-4" />
                        <span class="text-sm font-normal">Group by</span>
                    </div>
                    <ButtonPopover
                        buttonClass="!p-0 !justify-end btn-base btn-transparent !font-normal"
                        popoverClass="bg-white dark:bg-slate-800 rounded-lg shadow-lg dark:shadow-slate-900/50 min-w-40 z-40 outline outline-1 outline-offset-[-1px] outline-slate-200 dark:outline-slate-700 p-2"
                    >
                        <template #button-content>
                            <span class="text-slate-800 dark:text-slate-100 text-sm">
                                {{ getGroupByLabel(insightsGroupBy) }}
                            </span>
                            <Icon
                                icon="chevron-down-small"
                                class="w-4 h-4 text-slate-400"
                            />
                        </template>
                        <template
                            #default="{ closePopover: closeGroupByPopover }"
                        >
                            <div class="flex flex-col gap-1">
                                <button
                                    v-for="option in groupByOptions"
                                    :key="option.value"
                                    type="button"
                                    class="self-stretch bg-white dark:bg-slate-800 inline-flex justify-start items-start flex-1 p-2 rounded text-slate-700 dark:text-slate-300 text-sm font-normal hover:bg-slate-100 dark:hover:bg-slate-700 focus:bg-slate-100 dark:focus:bg-slate-700 focus:outline-none"
                                    :class="{
                                        'bg-slate-100 dark:bg-slate-700':
                                            insightsGroupBy === option.value,
                                    }"
                                    @click="
                                        selectGroupBy(
                                            option.value,
                                            closeGroupByPopover
                                        )
                                    "
                                >
                                    {{ option.label }}
                                </button>
                            </div>
                        </template>
                    </ButtonPopover>
                </label>
                <hr class="my-2" />
                <!-- Show Card Numbers Toggle -->
                <label
                    class="w-full h-9 p-2 rounded flex justify-between items-center"
                >
                    <div class="flex items-center gap-2">
                        <span class="text-slate-800 dark:text-slate-100 text-sm font-medium">
                            Show cards #s
                        </span>
                    </div>
                    <Switch
                        :value="insightsShowCardNumbers"
                        @input="toggleShowCardNumbers"
                    />
                </label>
            </section>
        </template>
    </ButtonPopover>
</template>

<script setup>
import { storeToRefs } from 'pinia';
import { useCardBenefitsStore } from '@/store/card-benefits';
import ButtonPopover from '@/components/ui/button-popover.vue';
import Switch from '@/components/ui/switch/switch.vue';
import Icon from '@/components/ui/icon/icon.vue';

const store = useCardBenefitsStore();
const { insightsGroupBy, insightsShowCardNumbers } = storeToRefs(store);

const groupByOptions = [
    { value: 'flat', label: 'None' },
    { value: 'by_card', label: 'Card' },
];

const selectGroupBy = (value, closePopover) => {
    store.setInsightsGroupBy(value);
    closePopover();
};

const toggleShowCardNumbers = () => {
    store.setInsightsShowCardNumbers(!insightsShowCardNumbers.value);
};

const getGroupByLabel = (mode) => {
    const option = groupByOptions.find((opt) => opt.value === mode);
    return option ? option.label : 'None';
};
</script>
